/**
* @Author: zachalam
* @Date:   2017-01-31T10:47:31-08:00
* @Last modified by:   zachalam
* @Last modified time: 2017-01-31T10:47:31-08:00
*/

// stores meta information from api.
import _ from 'lodash';

let initialState = {
  items:[],
  isFetching: false
};

const mail = (state = initialState, action) => {
  switch(action.type) {
    case 'REQUEST_MAIL':
      return {
        ...state,
        isFetching: true
      }
      
    case 'STORE_MAILLIST':
      const items = state.items.concat(action.payload);
      return {
        ...state,
        items,
        isFetching: false
      }

    case 'CLEAR_MAIL':
      return {
        items: [],
        isFetching: false
      }

    default:
      return state;
  }
}



export default mail;



// WEBPACK FOOTER //
// ./src/reducers/mail.js